import { mediaMixin, spaceMixin, spacingMixin } from '@zillow/constellation';
import { css } from 'styled-components';

export default (props) =>
  props.theme &&
  props.theme.ns &&
  css`
    ${spacingMixin};
    margin: auto;
    padding-left: ${props.fluidMobile ? 0 : spaceMixin('xs')};
    padding-right: ${props.fluidMobile ? 0 : spaceMixin('xs')};
    position: relative;

    max-width: ${props.maxWidth};

    ${mediaMixin(
      'sm',
      css`
        max-width: 100%;
      `,
    )}

    ${mediaMixin(
      'md',
      css`
        max-width: 100%;
      `,
    )}

        ${mediaMixin(
      'lg',
      css`
        max-width: ${props.maxWidth};
        padding-left: ${spaceMixin(1.5)};
        padding-right: ${spaceMixin(1.5)};
      `,
    )}
        ${mediaMixin(
      'xl',
      css`
        max-width: ${props.maxWidth};
      `,
    )}
        ${mediaMixin(
      'xxl',
      css`
        max-width: ${props.maxWidth};
        padding-left: 0;
        padding-right: 0;
      `,
    )}

        ${props.fluid &&
    mediaMixin(
      'xs',
      css`
        max-width: ${props.maxWidth};
      `,
    )}

        /* IE10 display: -ms-flexbox (and display: flex in IE 11) does not work inside a table; fall back to block and rely on font hack */
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      table & {
        display: block;
      }
    }

    /* Opera as of 12 on Windows needs word-spacing.
           The ".opera-only" selector is used to prevent actual prefocus styling
           and is not required in markup.
        */
    .opera-only :-o-prefocus,
    .pure-g {
      word-spacing: -0.43em;
    }
  `;
